import * as t from "io-ts";
import nullable from "./nullable";
import { withFallback } from "io-ts-types";
export const cargoTagT = t.strict({
    id: t.string,
    color: t.string,
    description: t.string,
});
export const newShipmentDateOptionT = t.union([
    t.literal("0"),
    t.literal("1"),
    t.literal("2"),
    t.literal("3"),
    t.literal("4"),
    t.literal("5"),
    t.literal("6"),
    t.literal("7"),
]);
export const newShipmentDateRequestResponseT = t.strict({
    value: newShipmentDateOptionT,
});
export const routeSearchIntervalRequestResponseT = t.strict({
    value: newShipmentDateOptionT,
});
export const defaultDispatcherViewT = t.union([
    t.literal("ROUTES_VIEW"),
    t.literal("CALENDAR_VIEW"),
    t.literal("COMPACT_VIEW"),
]);
export const calendarViewFirstRowOptionsT = t.union([
    t.literal("POSTCODE_CITY"),
    t.literal("CITY"),
]);
export const calendarViewSecondThirdRowOptionsT = t.union([
    t.literal("CLIENT"),
    t.literal("CARGO_DESCRIPTION"),
    t.null,
]);
export const archiveRoutesUntilOptionOneWeekT = t.literal("1 WEEK");
export const archiveRoutesUntilOptionTwoWeeksT = t.literal("2 WEEKS");
export const archiveRoutesUntilOptionOneMonthT = t.literal("1 MONTH");
export const archiveRoutesUntilOptionThreeMonthsT = t.literal("3 MONTHS");
export const archiveRoutesUntilOptionT = t.union([
    archiveRoutesUntilOptionOneWeekT,
    archiveRoutesUntilOptionTwoWeeksT,
    archiveRoutesUntilOptionOneMonthT,
    archiveRoutesUntilOptionThreeMonthsT,
    t.null,
]);
export const calendarViewSettingsT = t.strict({
    firstRow: calendarViewFirstRowOptionsT,
    secondRow: calendarViewSecondThirdRowOptionsT,
    thirdRow: calendarViewSecondThirdRowOptionsT,
});
export const deliveryAddressPartT = t.union([
    t.literal("PLACE_NAME"),
    t.literal("STREET_ADDRESS"),
    t.literal("POSTCODE"),
    t.literal("CITY"),
]);
const invoiceFolderPriorityFieldT = t.union([
    t.strict({ field: t.literal("INVOICE_REFERENCE") }),
    t.strict({
        field: t.literal("DELIVERY_ADDRESS"),
        addressPart: deliveryAddressPartT,
    }),
    t.strict({
        field: t.literal("PICKUP_ADDRESS"),
        addressPart: deliveryAddressPartT,
    }),
]);
export const invoiceFolderOptionsT = t.union([
    t.strict({ mode: t.literal("MANUAL") }),
    t.strict({
        mode: t.literal("FROM_FIELD"),
        field: t.literal("INVOICE_REFERENCE"),
    }),
    t.strict({
        mode: t.literal("FROM_FIELD"),
        field: t.literal("DELIVERY_ADDRESS"),
        addressPart: deliveryAddressPartT,
    }),
    t.strict({
        mode: t.literal("FROM_FIELD"),
        field: t.literal("PICKUP_ADDRESS"),
        addressPart: deliveryAddressPartT,
    }),
    t.strict({
        mode: t.literal("PRIORITY_ORDER"),
        priority1: invoiceFolderPriorityFieldT,
        priority2: invoiceFolderPriorityFieldT,
    }),
]);
export const orgSettingsT = t.strict({
    cargoTags: t.array(cargoTagT),
    automaticArchiveRoutesUntil: archiveRoutesUntilOptionT,
    newShipmentDate: newShipmentDateOptionT,
    hideLoadmeters: t.boolean,
    clientRequiredOnCargos: t.boolean,
    hideCargoDescription: t.boolean,
    hideInvoiceRef: t.boolean,
    driverCanEditCargos: t.boolean,
    routeSearchInterval: newShipmentDateOptionT,
    showArrivedDepartureToDriver: t.boolean,
    showAddCubicMetersToDriver: t.boolean,
    showCargoTimeTrackingToDriver: t.boolean,
    hideCollectedDeliveredButtonsForDriver: t.boolean,
    newSyncedCustomersVisibleToDriver: t.boolean,
    newSyncedProductsVisibleToDriver: t.boolean,
    defaultDispatcherView: defaultDispatcherViewT,
    calendarViewSettings: withFallback(calendarViewSettingsT, {
        firstRow: "POSTCODE_CITY",
        secondRow: "CARGO_DESCRIPTION",
        thirdRow: "CLIENT",
    }),
    driverCanAddExtraStopsDefault: t.boolean,
    driverCanPickFromUndispatchedDefault: t.boolean,
    hideCargoFromDriversDefault: t.boolean,
    splitRouteCargoTeamId: nullable(t.string),
    splitCargosLabelId: nullable(t.string),
    fragmentCargosLabelId: nullable(t.string),
    invoiceFolderOptions: withFallback(invoiceFolderOptionsT, { mode: "MANUAL" }),
    equipmentEnabled: withFallback(t.boolean, false),
    fractionsEnabled: withFallback(t.boolean, false),
});
export const orgSettingsWithId = t.intersection([
    orgSettingsT,
    t.strict({ organisationId: t.string }),
]);
export const cargoTagsT = t.array(cargoTagT);
//# sourceMappingURL=org-settings.js.map